import { render, staticRenderFns } from "./lowPriceDetails.vue?vue&type=template&id=212bb787"
import script from "./lowPriceDetails.vue?vue&type=script&lang=js"
export * from "./lowPriceDetails.vue?vue&type=script&lang=js"
import style0 from "./lowPriceDetails.vue?vue&type=style&index=0&id=212bb787&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports